import { CircularProgress, Typography } from '@material-ui/core'
import React from 'react'
import CancelIcon from '@material-ui/icons/Cancel'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import { StatusLine } from '../../types'

export function StatusLineComponent(props: { status: StatusLine }) {
  const { status } = props
  if (status.fetching && status.message.length > 0) {
    return (
      <React.Fragment>
        <Typography className='margin-right' variant='body1'>
          <b>{status.message}</b>
        </Typography>
        <CircularProgress size={25} />
      </React.Fragment>
    )
  } else if (!status.fetching && status.failed) {
    return (
      <React.Fragment>
        <Typography className='margin-right' variant='body1'>
          <b>{status.message}</b>
        </Typography>
        <CancelIcon />
      </React.Fragment>
    )
  } else if (!status.fetching && !status.failed && status.message.length > 0) {
    return (
      <React.Fragment>
        <Typography className='margin-right' variant='body1'>
          <b>{status.message}</b>
        </Typography>
        <CheckCircleIcon />
      </React.Fragment>
    )
  }
  return null
}
